module.exports = __webpack_public_path__ + "img/bg_授权机构.fce4890b.png";